function CookiesHelper() { }

// usage
// CookiesHelper.createCookie("myCookieUniqueName", value, 30);
// CookiesHelper.createCookie("myJsonCookieUniqueName", json, 30);
CookiesHelper.createCookie = function (name, value, days, hours) {
    var expires = "";
    days = (days || 0) * 24;
    if (days || hours) {
        var date = new Date();
        date.setTime(date.getTime() + ((days + hours) * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

// usage
// var value = CookiesHelper.readCookie("myCookieUniqueName");
// var json = JSON.parse(CookiesHelper.readCookie("myJsonCookieUniqueName");
CookiesHelper.readCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

CookiesHelper.readCookieValue = function (cookieName, propertyName) {
    var cookieContent = CookiesHelper.readCookie(cookieName);
    if (cookieContent !== null) {
        var groups = cookieContent && cookieContent.split('&');
        for (var i = 0; i < groups.length; i++) {
            var g = groups[i];
            var t = g.split('=');

            if (t[0] === propertyName)
                return t[1];
        }
    }
    return null;
}

CookiesHelper.updateCookieValue = function (cookieName, propertyName, value, days, hours) {

    console.log('cookieName', cookieName);
    console.log('propertyName', propertyName);
    console.log('value', value);
    console.log('days', days);
    console.log('hours', hours);

    var cookieContent = CookiesHelper.readCookie(cookieName);

    console.log('cookieContent', cookieContent);

    if (cookieContent !== null) {


        var groups = cookieContent && cookieContent.split('&');

        console.log('groups before', groups);

        for (var i = 0; i < groups.length; i++) {
            var g = groups[i];
            var t = g.split('=');

            if (t[0] === propertyName) {
                //update cookie value
                t[1] = value;
                //join it up again
                groups[i] = t.join('=');
            }
        }

        console.log('groups after', groups);

        CookiesHelper.createCookie(cookieName, groups.join('&'), days, hours);
    }

}


CookiesHelper.eraseCookie = function (name) {
    createCookie(name, "", -1);
}